module.exports = __webpack_public_path__ + "static/media/ar.a911f576.svg";